import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import './css/Portifolio.css';

const EXPERIENCES = [
  {
    image: 'https://i3.ypcdn.com/blob/910ed70ed2fcae8d339a440fa61feb1fada62726',
    company: 'Best Buy',
    role: 'Computer Sales Advisor',
    duration: 'Nov 2023 – Apr 2025',
    description:
      'Provided technical support, troubleshooting, and guidance to customers on various computer-related issues. Consistently exceeded sales targets while delivering exceptional customer experiences.',
  },
  {
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-uRbW9kTFZFVMGpQJjrDKE_HF0zMhfSMP_w&s',
    company: 'Freelance – Premium Wraps FL',
    role: 'Freelance Web Developer',
    duration: 'Dec 2022 – Feb 2023',
    description:
      'Led a team of two in the development of a full website for an automotive dealership in Florida, improving online visibility and increasing vehicle order volume.',
  },
  {
    image: 'https://raichu-uploads.s3.amazonaws.com/logo_justa_G1yKwU.png',
    company: 'Justa Soluções Financeiras',
    role: 'Data Scientist Junior',
    duration: 'Oct 2021 – Aug 2022',
    description:
      'Conducted data analysis and built Python automation bots with web scraping. Reduced manual processes by 50% and saved ~$6,000 USD through logistics optimization.',
  },
];

const SKILLS = [
  { label: 'Languages', value: 'C#, Java, Python, JavaScript, TypeScript' },
  { label: 'Web', value: 'React, Node.js, Express, HTML, CSS' },
  { label: 'Backend', value: 'Spring Boot, Django, REST APIs' },
  { label: 'Databases', value: 'MongoDB, PostgreSQL, Firebase' },
  { label: 'Game Dev', value: 'Unity, C#, Game Design' },
  { label: 'Tools', value: 'Git, Docker, Figma, Linux, Agile' },
];

const CERTS = [
  {
    title: 'Certified Entry-Level Python Programmer',
    link: 'https://www.credly.com/badges/72790fb6-16f2-41dd-a615-1533c5f28d0c/linked_in_profile',
    issuer: 'PCEP',
  },
  {
    title: 'Certified JavaScript Developer',
    link: 'https://verify.w3schools.com/1P1HOL91KP',
    issuer: 'W3Schools',
  },
];

export default function Landing() {
  const [text] = useTypewriter({
    words: ['Back End Developer', 'Game Developer', 'Software Engineer', 'Problem Solver'],
    loop: 0,
    typeSpeed: 65,
    deleteSpeed: 40,
    delaySpeed: 1800,
  });

  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetch('https://website-backend-production-2163.up.railway.app/api/projects')
      .then(r => r.json())
      .then(data => setProjects(data.reverse()))
      .catch(() => {});
  }, []);

  const filtered = projects.filter(p =>
    p.title?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="pf-page">
      <div className="pf-ambient" aria-hidden="true" />

      {/* ── STICKY NAV ── */}
      <nav className="pf-nav">
        <Link to="/" className="pf-nav-link">◄ HOME</Link>
        <span className="pf-nav-brand">FELIPPE NAGY</span>
        <Link to="/hub" className="pf-nav-link">HUB ►</Link>
      </nav>

      {/* ── HERO ── */}
      <header className="pf-hero">
        <div className="pf-hero-glow" aria-hidden="true" />
        <img
          src="/White3DKeycapFNNoBackground.png"
          alt="FN Logo"
          className="pf-logo"
        />
        <p className="pf-eyebrow">{'// PORTFOLIO_v2'}</p>
        <h1 className="pf-name">
          Hi, I'm <span className="pf-name-accent">Felippe</span>
          <span className="pf-dot">.</span>
        </h1>
        <h2 className="pf-typewriter">
          {text}<Cursor cursorStyle="_" cursorColor="#00ffff" />
        </h2>
        <p className="pf-tagline">
          Building products at the intersection of{' '}
          <span className="pf-tag-accent">performance</span> and{' '}
          <span className="pf-tag-accent">creativity</span>.
        </p>

        <div className="pf-socials">
          <a
            href="https://github.com/Felippefn"
            target="_blank"
            rel="noopener noreferrer"
            className="pf-social-link"
            aria-label="GitHub"
          >
            <i className="bi bi-github" />
          </a>
          <a
            href="https://linkedin.com/in/felippefn"
            target="_blank"
            rel="noopener noreferrer"
            className="pf-social-link"
            aria-label="LinkedIn"
          >
            <i className="bi bi-linkedin" />
          </a>
          <a
            href="mailto:flppprojects@outlook.com"
            className="pf-social-link"
            aria-label="Email"
          >
            <i className="bi bi-envelope-fill" />
          </a>
        </div>

        <div className="pf-cta-group">
          <a
            href="Felippe's Resume-hackerresume.pdf"
            className="pf-btn pf-btn--primary"
            download
          >
            <i className="bi bi-download" /> Resume
          </a>
          <a href="/hub" className="pf-btn pf-btn--outline">Hub</a>
          <a href="/about-me" className="pf-btn pf-btn--outline">Contact</a>
        </div>

        <div className="pf-scroll-hint" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </header>

      {/* ── ABOUT ── */}
      <section className="pf-section" id="about">
        <h2 className="pf-section-title">{'// ABOUT_ME'}</h2>
        <div className="pf-about-grid">

          {/* Left: bio + interests */}
          <div className="pf-glass-card">
            <img
              src="about-me/PROF_PIC.jpg"
              alt="Felippe"
              className="pf-profile-img"
              onError={e => { e.target.style.display = 'none'; }}
            />
            <p className="pf-bio">
              Hello! I'm <strong>Felippe Nagy</strong>, a passionate Computer Scientist.
              With a strong foundation in{' '}
              <strong>Node.js, Python, C#, ReactJS</strong> and Back End Development,
              I'm committed to creating innovative solutions.
              Fluent in <strong>English, Portuguese, and Spanish</strong>.
            </p>
            <div className="pf-interests">
              <span className="pf-interest-tag">🎮 Gaming</span>
              <span className="pf-interest-tag">💻 Programming</span>
              <span className="pf-interest-tag">🚀 Sci-Fi</span>
            </div>
          </div>

          {/* Right: education + certs + skills */}
          <div className="pf-right-col">
            <div className="pf-glass-card">
              <h3 className="pf-block-title">{'// EDUCATION'}</h3>
              <div className="pf-edu-item">
                <img
                  src="about-me/valencia.png"
                  alt="Valencia College"
                  className="pf-edu-logo"
                  onError={e => { e.target.style.display = 'none'; }}
                />
                <div>
                  <p className="pf-edu-degree">AS. Computer Science</p>
                  <p className="pf-edu-year">Valencia College · 2023</p>
                </div>
              </div>
            </div>

            <div className="pf-glass-card">
              <h3 className="pf-block-title">{'// CERTIFICATIONS'}</h3>
              {CERTS.map((cert, i) => (
                <a
                  key={i}
                  href={cert.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pf-cert-item"
                >
                  <span className="pf-cert-issuer">{cert.issuer}</span>
                  <span className="pf-cert-title">{cert.title}</span>
                  <span className="pf-cert-arrow">→</span>
                </a>
              ))}
            </div>

            <div className="pf-glass-card">
              <h3 className="pf-block-title">{'// SKILLS'}</h3>
              <div className="pf-skills-list">
                {SKILLS.map((s, i) => (
                  <div key={i} className="pf-skill-row">
                    <span className="pf-skill-label">{s.label}</span>
                    <span className="pf-skill-value">{s.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ── EXPERIENCE ── */}
      <section className="pf-section pf-section--alt" id="experience">
        <h2 className="pf-section-title">{'// WORK_EXPERIENCE'}</h2>
        <div className="pf-timeline">
          {EXPERIENCES.map((exp, i) => (
            <div key={i} className="pf-timeline-item">
              <div className="pf-timeline-connector" aria-hidden="true">
                <div className="pf-timeline-dot" />
                {i < EXPERIENCES.length - 1 && <div className="pf-timeline-line" />}
              </div>
              <div className="pf-exp-card">
                <div className="pf-exp-header">
                  {exp.image && (
                    <img
                      src={exp.image}
                      alt={exp.company}
                      className="pf-exp-logo"
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                  )}
                  <div>
                    <h3 className="pf-exp-company">{exp.company}</h3>
                    <p className="pf-exp-role">{exp.role}</p>
                    <p className="pf-exp-duration">{exp.duration}</p>
                  </div>
                </div>
                <p className="pf-exp-desc">{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── PROJECTS ── */}
      <section className="pf-section" id="projects">
        <h2 className="pf-section-title">{'// PROJECTS'}</h2>
        <div className="pf-search-wrap">
          <i className="bi bi-search pf-search-icon" aria-hidden="true" />
          <input
            type="text"
            placeholder="Search projects..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="pf-search"
          />
        </div>
        {filtered.length === 0 && (
          <p className="pf-empty">No projects found.</p>
        )}
        <div className="pf-projects-grid">
          {filtered.map((p, i) => (
            <a
              key={i}
              href={p.github || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="pf-project-card"
            >
              <div className="pf-project-img-wrap">
                <img
                  src={p.imageUrl || 'Designer3DFNKeycap.png'}
                  alt={p.title}
                  className="pf-project-img"
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = 'Designer3DFNKeycap.png';
                  }}
                />
                <div className="pf-project-overlay" aria-hidden="true" />
              </div>
              <div className="pf-project-body">
                <h3 className="pf-project-title">{p.title || 'Untitled'}</h3>
                <p className="pf-project-text">{p.text}</p>
                <span className="pf-project-cta">View on GitHub →</span>
              </div>
              <div className="pf-project-accent" aria-hidden="true" />
            </a>
          ))}
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="pf-footer">
        <div className="pf-footer-links">
          <a href="https://github.com/Felippefn" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <i className="bi bi-github" />
          </a>
          <a href="https://www.linkedin.com/in/felippefn/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="bi bi-linkedin" />
          </a>
          <a href="mailto:flppprojects@outlook.com" aria-label="Email">
            <i className="bi bi-envelope-fill" />
          </a>
        </div>
        <p className="pf-footer-copy">
          © {new Date().getFullYear()} Felippe Nagy — FN Studios. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
